import React from "react";

export const HamburgerIcon = ({ customClass, clickAction, theme }) => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={clickAction}
    >
      <path
        d="M0 0H18V2H0V0ZM0 7H18V9H0V7ZM0 14H18V16H0V14Z"
        fill={theme === "light" ? "#595959" : "#FFFFFF"}
      />
    </svg>
  );
};

export const ArrowDown = ({ customClass, color = "#FFFFFF", action }) => {
  return (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={action}
    >
      <path
        d="M6.364 5.172L1.414 0.222L0 1.636L6.364 8L12.728 1.636L11.314 0.222L6.364 5.172Z"
        fill={color}
      />
    </svg>
  );
};

export const TradeIcon = () => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0098 0C12.1184 0 2.63987e-10 12.1184 2.63987e-10 27.0098V34.542C-3.41428e-06 34.7085 0.0331174 34.8733 0.097434 35.0269C0.161751 35.1805 0.255978 35.3198 0.374631 35.4366C0.493284 35.5534 0.633991 35.6455 0.788562 35.7074C0.943133 35.7693 1.10848 35.7999 1.27497 35.7973H8.98365C9.17299 36.4131 9.50483 36.9629 9.94479 37.4057C10.1591 37.6214 10.1506 37.5783 10.2586 37.6607C10.3666 37.7431 10.5003 37.8488 10.6705 37.9746C11.011 38.226 11.4777 38.5596 12.024 38.9553C13.1166 39.7468 14.5321 40.7855 15.947 41.7995C18.7701 43.8228 21.544 45.7918 21.5568 45.8009H21.5765C22.756 46.6591 24.3048 46.6384 25.4602 45.8794C26.2566 46.3297 27.0292 46.4678 27.6375 46.4678C29.5741 46.4678 32.3289 45.5722 35.2677 44.4475C38.1964 43.3267 41.1064 41.9734 42.8783 40.7599C42.8845 40.7536 42.8918 40.7447 42.8979 40.7403C43.854 40.1139 44.5848 39.0703 44.5848 37.955C44.5848 37.3724 44.4316 36.8016 44.1729 36.3269C44.0653 36.1295 43.9076 35.9689 43.7806 35.7973H49.8024C46.2683 44.9659 37.4347 51.4893 27.0098 51.4893C20.3075 51.4893 14.1933 48.8979 9.76825 44.5848H11.9455C12.1119 44.5872 12.277 44.5564 12.4314 44.4944C12.5858 44.4324 12.7263 44.3403 12.8447 44.2235C12.9632 44.1067 13.0573 43.9675 13.1215 43.814C13.1857 43.6605 13.2188 43.4958 13.2188 43.3295C13.2188 43.1631 13.1857 42.9984 13.1215 42.8449C13.0573 42.6914 12.9632 42.5522 12.8447 42.4354C12.7263 42.3186 12.5858 42.2265 12.4314 42.1645C12.277 42.1025 12.1119 42.0717 11.9455 42.0741H6.92408C6.88487 42.0723 6.8456 42.0723 6.80639 42.0741C6.49426 42.1035 6.20443 42.2486 5.9939 42.481C5.78337 42.7133 5.66737 43.0159 5.66873 43.3295V48.3509C5.66637 48.5172 5.6971 48.6824 5.75914 48.8368C5.82117 48.9911 5.91326 49.1316 6.03007 49.2501C6.14687 49.3686 6.28606 49.4626 6.43953 49.5269C6.59301 49.5911 6.75772 49.6241 6.92408 49.6241C7.09045 49.6241 7.25516 49.5911 7.40863 49.5269C7.56211 49.4626 7.70129 49.3686 7.8181 49.2501C7.9349 49.1316 8.027 48.9911 8.08903 48.8368C8.15106 48.6824 8.18179 48.5172 8.17944 48.3509V46.5659C13.0609 51.2362 19.7429 54 27.0098 54C39.0589 54 49.1643 46.023 52.6269 35.1108C52.6414 35.0787 52.6545 35.0459 52.6662 35.0127C52.7013 34.9307 52.7276 34.8453 52.7446 34.7577C52.753 34.7188 52.7596 34.6795 52.7643 34.64C53.4885 32.2031 54 29.6798 54 27.0098V18.2223C54 17.8894 53.8677 17.5701 53.6323 17.3347C53.3969 17.0992 53.0776 16.967 52.7446 16.9669H39.9361L29.4224 12.0632C29.1977 11.9524 28.9449 11.9114 28.6967 11.9455C28.5738 11.967 28.4548 12.0067 28.3436 12.0632L18.2811 16.9669H4.68798C8.51604 8.45843 17.0594 2.54995 27.0098 2.54995C33.7121 2.54995 39.8085 5.12478 44.2317 9.4348H42.0741C41.9077 9.43245 41.7426 9.46318 41.5882 9.52521C41.4339 9.58724 41.2934 9.67934 41.1749 9.79614C41.0564 9.91294 40.9623 10.0521 40.8981 10.2056C40.8339 10.3591 40.8009 10.5238 40.8009 10.6902C40.8009 10.8565 40.8339 11.0212 40.8981 11.1747C40.9623 11.3282 41.0564 11.4674 41.1749 11.5842C41.2934 11.701 41.4339 11.7931 41.5882 11.8551C41.7426 11.9171 41.9077 11.9479 42.0741 11.9455H47.0955C47.4285 11.9455 47.7477 11.8132 47.9832 11.5778C48.2186 11.3424 48.3509 11.0231 48.3509 10.6902V5.66873C48.3547 5.49002 48.3204 5.31255 48.2501 5.14819C48.1799 4.98382 48.0753 4.83636 47.9435 4.71566C47.8116 4.59496 47.6555 4.5038 47.4856 4.44829C47.3157 4.39277 47.1359 4.37418 46.9582 4.39375C46.6462 4.42804 46.3584 4.57796 46.1514 4.81395C45.9445 5.04995 45.8334 5.35491 45.8402 5.66873V7.4733C40.9587 2.80182 34.2772 0 27.0098 0ZM28.8928 14.5935L39.1319 19.36C39.2977 19.4373 39.4785 19.4775 39.6615 19.4777H51.4893V27.0098C51.4893 29.1975 51.1236 31.2695 50.587 33.2866H41.6622L28.579 18.6342C28.4085 18.4433 28.1838 18.3091 27.9349 18.2495C27.686 18.1899 27.4248 18.2078 27.1863 18.3008L19.2815 21.3215C19.2757 21.3233 19.2678 21.3202 19.2619 21.3215C19.1954 21.3385 19.1191 21.3607 19.0461 21.3607C18.7455 21.3607 18.2223 20.7701 18.2223 20.3015C18.2223 19.9923 18.3936 19.739 18.6342 19.5954C18.6392 19.5922 18.6291 19.5786 18.6342 19.5757L28.8928 14.5935ZM3.72684 19.4777H15.947C15.8725 19.7539 15.7116 20.0035 15.7116 20.3015C15.7116 22.1291 17.047 23.8714 19.0461 23.8714C19.3569 23.8714 19.6622 23.8139 19.9484 23.7341C19.9883 23.723 20.0275 23.7099 20.0661 23.6949L27.2648 20.9488L41.3483 36.6996C41.3535 36.7059 41.3433 36.7136 41.3483 36.7192C41.679 37.1006 41.8908 37.3671 41.976 37.5234C42.0625 37.6822 42.0741 37.7206 42.0741 37.955C42.0741 38.308 42.1286 38.2587 41.5053 38.6611C41.4987 38.6676 41.4921 38.6741 41.4856 38.6807C40.0849 39.6434 37.1807 41.0163 34.3654 42.0937C31.5501 43.1712 28.6256 43.9571 27.6375 43.9571C27.2467 43.9571 27.1433 43.9889 26.8921 43.8394C27.1831 42.5804 26.7355 41.1982 25.6564 40.3676L25.676 40.348C25.676 40.348 25.6177 40.3088 25.6171 40.3088C25.5645 40.2654 23.1214 38.2319 20.5565 36.1111C19.2603 35.0395 17.9504 33.972 16.9277 33.1297C15.9051 32.2874 15.2748 31.7653 15.0054 31.5605C14.3583 31.0681 13.5376 30.7759 12.6713 30.7759C11.0307 30.7759 9.64096 31.8345 9.08173 33.2866H2.54995V27.0098C2.54995 24.3778 2.96111 21.8517 3.72684 19.4777ZM12.6713 33.2866C12.9872 33.2866 13.266 33.3673 13.4951 33.5416C13.4904 33.5353 14.3186 34.2116 15.3389 35.0519C16.3592 35.8923 17.6722 36.9818 18.9677 38.053C21.5587 40.1953 24.0872 42.2899 24.0872 42.2899C24.1064 42.3035 24.126 42.3166 24.146 42.3291C24.5643 42.6369 24.6353 43.1495 24.3226 43.5648C24.0018 43.9907 23.4604 44.0844 23.0476 43.7806C23.0411 43.774 23.0346 43.7675 23.028 43.761C23.028 43.761 20.2442 41.7849 17.4181 39.7595C16.005 38.7468 14.5811 37.7216 13.4951 36.935C12.9521 36.5417 12.49 36.197 12.1613 35.9542C11.9969 35.8328 11.8582 35.7477 11.769 35.6796C11.6797 35.6115 11.5539 35.4631 11.7297 35.6404C11.4777 35.3865 11.3178 35.0514 11.3178 34.6596C11.3178 33.8754 11.91 33.2866 12.6713 33.2866Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="44.7859"
        y1="6.31579"
        x2="-0.855307"
        y2="24.5067"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
    </defs>
  </svg>
);

export const CommoditiesIcon = () => (
  <svg
    width="66"
    height="55"
    viewBox="0 0 66 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M65.1104 29.8021L57.7659 16.7481C57.5612 16.3806 57.1752 16.1527 56.7519 16.1527H49.6214L53.0053 3.52198C53.1704 2.90103 52.8029 2.2638 52.182 2.09867L44.4956 0.0404556C43.877 -0.126993 43.2421 0.240463 43.0746 0.863743L40.2396 11.4269C38.6187 9.61757 36.2883 8.45706 33.672 8.45706C32.8812 8.45706 32.1277 8.5966 31.3951 8.79195V5.9965C31.3951 5.35229 30.8765 4.83366 30.2323 4.83366H16.6713C16.0271 4.83366 15.5085 5.35229 15.5085 5.9965V16.1527H8.5082C8.08726 16.1527 7.69887 16.3806 7.49421 16.7481L0.149746 29.8021C-0.0525875 30.1602 -0.0502618 30.6021 0.159049 30.9602C0.368359 31.3137 0.749769 31.5347 1.16374 31.5347H7.75469V53.2216C7.75469 53.8611 8.27564 54.3844 8.91752 54.3844H55.4309C56.0705 54.3844 56.5938 53.8611 56.5938 53.2216V31.5347H64.0987C64.5127 31.5347 64.8941 31.3137 65.1034 30.9602C65.3104 30.6021 65.315 30.1602 65.1104 29.8021ZM45.0189 2.58706L50.4563 4.04293L47.212 16.1527H42.4142C42.3188 15.4573 42.1653 14.7829 41.9188 14.1456L45.0189 2.58706ZM40.0885 16.1527H27.2531C27.8043 13.1037 30.4649 10.7804 33.672 10.7804C36.8767 10.7804 39.5373 13.1037 40.0885 16.1527ZM17.8341 7.15933H29.0718V9.78036C26.8461 11.1455 25.2879 13.4526 24.9298 16.1527H17.8341V7.15933ZM9.18963 18.4784H39.6675L33.6301 29.209H3.15219L9.18963 18.4784ZM10.0804 31.5347H34.3138C34.7348 31.5347 35.1232 31.3068 35.3278 30.9416L40.4978 21.7552V52.0587H10.0804V31.5347ZM54.2681 52.0587H42.8211V21.7552L47.9888 30.9416C48.1958 31.3068 48.5818 31.5347 49.0028 31.5347H54.2704V52.0587H54.2681ZM49.6795 29.209L43.6444 18.4784H56.0728L62.1079 29.209H49.6795Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M24.2178 39.9699H14.222C13.5778 39.9699 13.0592 40.4909 13.0592 41.1327V47.9167C13.0592 48.5563 13.5778 49.0796 14.222 49.0796H24.2178C24.8597 49.0796 25.3806 48.5563 25.3806 47.9167V41.1327C25.3806 40.4909 24.8597 39.9699 24.2178 39.9699ZM23.0549 46.7539H15.3849V42.2956H23.0549V46.7539Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="54.1256"
        y1="6.36075"
        x2="2.10396"
        y2="31.2414"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="23.2782"
        y1="41.0354"
        x2="13.9272"
        y2="46.0763"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
    </defs>
  </svg>
);

export const ValueIcon = () => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M53 53.5043H1C0.734784 53.5043 0.48043 53.3989 0.292893 53.2114C0.105357 53.0238 0 52.7695 0 52.5043V24.5043C0 24.2391 0.105357 23.9847 0.292893 23.7972C0.48043 23.6096 0.734784 23.5043 1 23.5043H53C53.2652 23.5043 53.5196 23.6096 53.7071 23.7972C53.8946 23.9847 54 24.2391 54 24.5043V52.5043C54 52.7695 53.8946 53.0238 53.7071 53.2114C53.5196 53.3989 53.2652 53.5043 53 53.5043ZM2 51.5043H52V25.5043H2V51.5043Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M52.4109 25.5042H12.8609C12.6351 25.5119 12.4134 25.443 12.2318 25.3086C12.0502 25.1743 11.9195 24.9824 11.8609 24.7642C11.803 24.5504 11.8178 24.3234 11.9029 24.1189C11.9879 23.9144 12.1385 23.7439 12.3309 23.6342L42.0009 6.50422C42.115 6.4381 42.2411 6.39521 42.3719 6.37803C42.5027 6.36085 42.6356 6.3697 42.7629 6.4041C42.8902 6.43849 43.0095 6.49773 43.1139 6.57841C43.2182 6.6591 43.3056 6.75963 43.3709 6.87422L53.2809 24.0042C53.3687 24.1562 53.4149 24.3287 53.4149 24.5042C53.4149 24.6798 53.3687 24.8522 53.2809 25.0042C53.1928 25.1568 53.0659 25.2834 52.9132 25.3712C52.7604 25.459 52.5871 25.5049 52.4109 25.5042ZM16.5909 23.5042H50.6809L42.1509 8.75422L16.5909 23.5042Z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M12.8609 25.5043H8.30085C8.12464 25.505 7.95137 25.4591 7.7986 25.3713C7.64582 25.2835 7.51895 25.1569 7.43085 25.0043C7.34308 24.8522 7.29688 24.6798 7.29688 24.5043C7.29688 24.3287 7.34308 24.1563 7.43085 24.0043L21.0008 0.504259C21.0664 0.389491 21.1541 0.288861 21.2588 0.208187C21.3635 0.127514 21.4832 0.0683985 21.6109 0.0342591C21.7379 0.00012413 21.8704 -0.00861396 22.0008 0.0085457C22.1312 0.0257054 22.257 0.0684255 22.3709 0.134259L38.2309 9.29426C38.3847 9.38148 38.5128 9.50796 38.6018 9.6608C38.6909 9.81364 38.7378 9.98736 38.7378 10.1643C38.7378 10.3412 38.6909 10.5149 38.6018 10.6677C38.5128 10.8206 38.3847 10.947 38.2309 11.0343L13.3408 25.3843C13.1934 25.4638 13.0284 25.5051 12.8609 25.5043ZM10.0008 23.5043H12.6009L35.7409 10.1443L22.2508 2.35426L10.0008 23.5043Z"
      fill="url(#paint2_linear)"
    />
    <path
      d="M45 49.5043H9C8.73478 49.5043 8.48043 49.3989 8.29289 49.2114C8.10536 49.0238 8 48.7695 8 48.5043C8 47.7086 7.68393 46.9456 7.12132 46.383C6.55871 45.8203 5.79565 45.5043 5 45.5043C4.73478 45.5043 4.48043 45.3989 4.29289 45.2114C4.10536 45.0238 4 44.7695 4 44.5043V32.5043C4 32.2391 4.10536 31.9847 4.29289 31.7972C4.48043 31.6096 4.73478 31.5043 5 31.5043C5.79565 31.5043 6.55871 31.1882 7.12132 30.6256C7.68393 30.063 8 29.2999 8 28.5043C8 28.2391 8.10536 27.9847 8.29289 27.7972C8.48043 27.6096 8.73478 27.5043 9 27.5043H45C45.2652 27.5043 45.5196 27.6096 45.7071 27.7972C45.8946 27.9847 46 28.2391 46 28.5043C46 29.2999 46.3161 30.063 46.8787 30.6256C47.4413 31.1882 48.2043 31.5043 49 31.5043C49.2652 31.5043 49.5196 31.6096 49.7071 31.7972C49.8946 31.9847 50 32.2391 50 32.5043V44.5043C50 44.7695 49.8946 45.0238 49.7071 45.2114C49.5196 45.3989 49.2652 45.5043 49 45.5043C48.2043 45.5043 47.4413 45.8203 46.8787 46.383C46.3161 46.9456 46 47.7086 46 48.5043C46 48.7695 45.8946 49.0238 45.7071 49.2114C45.5196 49.3989 45.2652 49.5043 45 49.5043ZM9.9 47.5043H44.1C44.296 46.5434 44.7702 45.6613 45.4636 44.9679C46.1571 44.2745 47.0391 43.8002 48 43.6043V33.4043C47.0391 33.2083 46.1571 32.7341 45.4636 32.0407C44.7702 31.3472 44.296 30.4652 44.1 29.5043H9.9C9.70403 30.4652 9.22982 31.3472 8.53638 32.0407C7.84294 32.7341 6.96089 33.2083 6 33.4043V43.6043C6.96089 43.8002 7.84294 44.2745 8.53638 44.9679C9.22982 45.6613 9.70403 46.5434 9.9 47.5043Z"
      fill="url(#paint3_linear)"
    />
    <path
      d="M47.7809 25.5042H20.8609C20.6351 25.512 20.4134 25.443 20.2318 25.3087C20.0502 25.1743 19.9195 24.9824 19.8609 24.7642C19.803 24.5504 19.8178 24.3234 19.9029 24.1189C19.9879 23.9144 20.1385 23.7439 20.3309 23.6342L37.0609 13.9742C37.1748 13.9084 37.3005 13.8657 37.4309 13.8485C37.5614 13.8314 37.6939 13.8401 37.8209 13.8742C37.9486 13.9084 38.0683 13.9675 38.173 14.0482C38.2777 14.1288 38.3653 14.2295 38.4309 14.3442C38.6275 14.6857 38.8894 14.985 39.2017 15.2252C39.5139 15.4655 39.8705 15.6418 40.2509 15.7442C41.0175 15.9483 41.8337 15.8404 42.5209 15.4442C42.6341 15.3767 42.7595 15.3322 42.8899 15.3134C43.0203 15.2945 43.1532 15.3016 43.2809 15.3342C43.536 15.4089 43.7537 15.5766 43.8909 15.8042L48.6209 24.0042C48.7087 24.1562 48.7549 24.3287 48.7549 24.5042C48.7549 24.6798 48.7087 24.8522 48.6209 25.0042C48.5354 25.1525 48.4132 25.2763 48.2662 25.3639C48.1191 25.4514 47.952 25.4997 47.7809 25.5042ZM24.5909 23.5042H46.0509L42.6309 17.5842C41.7025 17.8942 40.7035 17.9249 39.7578 17.6725C38.8121 17.4201 37.9613 16.8957 37.3109 16.1642L24.5909 23.5042Z"
      fill="url(#paint4_linear)"
    />
    <path
      d="M13.0007 25.5042C12.8691 25.505 12.7387 25.4798 12.6168 25.43C12.495 25.3802 12.3842 25.3069 12.2907 25.2142C12.1342 25.0585 12.0337 24.8553 12.0047 24.6365C11.9758 24.4176 12.0201 24.1953 12.1307 24.0042L20.5207 9.46423C20.658 9.23663 20.8757 9.06888 21.1307 8.99423C21.2584 8.96158 21.3913 8.95449 21.5217 8.97337C21.6521 8.99224 21.7776 9.03672 21.8907 9.10423C22.5793 9.49933 23.3964 9.60542 24.163 9.39923C24.9296 9.19305 25.5833 8.69142 25.9807 8.00423C26.0463 7.88946 26.134 7.78883 26.2387 7.70815C26.3434 7.62748 26.463 7.56837 26.5907 7.53423C26.8476 7.47059 27.1191 7.50631 27.3507 7.63423L34.2907 11.6342C34.4446 11.7214 34.5726 11.8479 34.6617 12.0008C34.7508 12.1536 34.7977 12.3273 34.7977 12.5042C34.7977 12.6811 34.7508 12.8548 34.6617 13.0077C34.5726 13.1605 34.4446 13.287 34.2907 13.3742L13.5007 25.3742C13.3483 25.4606 13.1759 25.5054 13.0007 25.5042ZM21.8007 11.2442L15.6807 21.7242L31.7407 12.5042L27.0807 9.82423C26.4295 10.5576 25.577 11.0832 24.6293 11.3357C23.6815 11.5882 22.6805 11.5564 21.7507 11.2442H21.8007Z"
      fill="url(#paint5_linear)"
    />
    <path
      d="M27 45.5043C25.6155 45.5043 24.2622 45.0937 23.111 44.3246C21.9599 43.5554 21.0627 42.4621 20.5328 41.1831C20.003 39.904 19.8644 38.4965 20.1345 37.1386C20.4046 35.7808 21.0713 34.5335 22.0503 33.5545C23.0292 32.5756 24.2765 31.9089 25.6344 31.6388C26.9922 31.3687 28.3997 31.5073 29.6788 32.0371C30.9579 32.5669 32.0511 33.4641 32.8203 34.6153C33.5895 35.7664 34 37.1198 34 38.5043C34 40.3608 33.2625 42.1413 31.9498 43.454C30.637 44.7668 28.8565 45.5043 27 45.5043ZM27 33.5043C26.0111 33.5043 25.0444 33.7975 24.2222 34.3469C23.3999 34.8963 22.759 35.6772 22.3806 36.5909C22.0022 37.5045 21.9032 38.5098 22.0961 39.4797C22.289 40.4496 22.7652 41.3405 23.4645 42.0398C24.1637 42.7391 25.0546 43.2153 26.0246 43.4082C26.9945 43.6011 27.9998 43.5021 28.9134 43.1237C29.8271 42.7452 30.6079 42.1044 31.1574 41.2821C31.7068 40.4599 32 39.4932 32 38.5043C32 37.1782 31.4732 35.9064 30.5355 34.9687C29.5979 34.0311 28.3261 33.5043 27 33.5043Z"
      fill="url(#paint6_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="44.7859"
        y1="27.013"
        x2="9.86672"
        y2="52.0645"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="46.3185"
        y1="8.60755"
        x2="23.0463"
        y2="28.7668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="33.373"
        y1="2.98296"
        x2="8.56618"
        y2="15.1714"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="42.1509"
        y1="30.0774"
        x2="15.5614"
        y2="52.236"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="43.8187"
        y1="15.2043"
        x2="29.4865"
        y2="29.3707"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="30.907"
        y1="9.60878"
        x2="13.1097"
        y2="18.5939"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="31.6112"
        y1="33.1417"
        x2="19.7783"
        y2="37.8579"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192BD1" />
        <stop offset="1" stopColor="#1427D2" />
      </linearGradient>
    </defs>
  </svg>
);

export const One = () => (
  <svg
    width="53"
    height="38"
    viewBox="0 0 53 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M25.344 31.968L26.1353 32.5795L26.1397 32.5737L25.344 31.968ZM25.344 6.48L24.5483 7.0857L24.5527 7.09145L25.344 6.48ZM4.848 6.48L5.63931 7.09146L5.6437 7.08568L4.848 6.48ZM4.848 31.968L4.05227 32.5737L4.05672 32.5794L4.848 31.968ZM26.1397 32.5737C28.7539 29.1393 30.04 24.6838 30.04 19.2H28.04C28.04 24.3722 26.8301 28.3647 24.5483 31.3623L26.1397 32.5737ZM30.04 19.2C30.04 13.7183 28.7548 9.25854 26.1353 5.86855L24.5527 7.09145C26.8292 10.0375 28.04 14.0257 28.04 19.2H30.04ZM26.1397 5.87431C23.4831 2.38426 19.7666 0.679998 15.12 0.679998V2.68C19.2094 2.68 22.3089 4.14373 24.5483 7.08568L26.1397 5.87431ZM15.12 0.679998C10.4776 0.679998 6.71121 2.38123 4.0523 5.87431L5.6437 7.08568C7.88079 4.14677 11.0264 2.68 15.12 2.68V0.679998ZM4.05672 5.86855C1.43331 9.26355 0.2 13.7267 0.2 19.2H2.2C2.2 14.0173 3.36669 10.0324 5.63929 7.09145L4.05672 5.86855ZM0.2 19.2C0.2 24.6755 1.43423 29.1343 4.0523 32.5737L5.6437 31.3623C3.36577 28.3697 2.2 24.3805 2.2 19.2H0.2ZM4.05672 32.5794C6.71538 36.0201 10.4789 37.72 15.12 37.72V35.72C11.0251 35.72 7.87662 34.2519 5.63929 31.3566L4.05672 32.5794ZM15.12 37.72C19.7653 37.72 23.4789 36.0171 26.1353 32.5794L24.5527 31.3566C22.3131 34.2549 19.2107 35.72 15.12 35.72V37.72ZM10.792 19.2C10.792 16.2166 11.2323 14.1355 11.9889 12.832C12.6977 11.6106 13.7 11.032 15.12 11.032V9.032C12.988 9.032 11.3263 9.98936 10.2591 11.828C9.23969 13.5845 8.792 16.0874 8.792 19.2H10.792ZM15.12 11.032C16.54 11.032 17.5423 11.6106 18.2511 12.832C19.0077 14.1355 19.448 16.2166 19.448 19.2H21.448C21.448 16.0874 21.0003 13.5845 19.9809 11.828C18.9137 9.98936 17.252 9.032 15.12 9.032V11.032ZM19.448 19.2C19.448 22.1834 19.0077 24.2645 18.2511 25.568C17.5423 26.7894 16.54 27.368 15.12 27.368V29.368C17.252 29.368 18.9137 28.4106 19.9809 26.572C21.0003 24.8155 21.448 22.3126 21.448 19.2H19.448ZM15.12 27.368C13.7 27.368 12.6977 26.7894 11.9889 25.568C11.2323 24.2645 10.792 22.1834 10.792 19.2H8.792C8.792 22.3126 9.23969 24.8155 10.2591 26.572C11.3263 28.4106 12.988 29.368 15.12 29.368V27.368ZM34.5713 5.664L34.2343 4.72248L33.3532 5.03782L33.6095 5.93788L34.5713 5.664ZM36.6353 12.912L35.6735 13.1859L35.9396 14.1205L36.8815 13.8812L36.6353 12.912ZM42.4912 11.424H43.4912V10.1381L42.245 10.4548L42.4912 11.424ZM42.4912 36H41.4912V37H42.4912V36ZM51.0832 36V37H52.0832V36H51.0832ZM51.0832 2.4H52.0832V1.4H51.0832V2.4ZM43.6912 2.4V1.4H43.5177L43.3543 1.45848L43.6912 2.4ZM33.6095 5.93788L35.6735 13.1859L37.597 12.6381L35.533 5.39012L33.6095 5.93788ZM36.8815 13.8812L42.7375 12.3932L42.245 10.4548L36.389 11.9428L36.8815 13.8812ZM41.4912 11.424V36H43.4912V11.424H41.4912ZM42.4912 37H51.0832V35H42.4912V37ZM52.0832 36V2.4H50.0832V36H52.0832ZM51.0832 1.4H43.6912V3.4H51.0832V1.4ZM43.3543 1.45848L34.2343 4.72248L34.9082 6.60552L44.0282 3.34152L43.3543 1.45848Z"
      fill="#827F98"
    />
  </svg>
);

export const Two = () => (
  <svg
    width="60"
    height="38"
    viewBox="0 0 60 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M25.344 31.968L26.1353 32.5795L26.1397 32.5737L25.344 31.968ZM25.344 6.48L24.5483 7.0857L24.5527 7.09145L25.344 6.48ZM4.848 6.48L5.63931 7.09146L5.6437 7.08568L4.848 6.48ZM4.848 31.968L4.05227 32.5737L4.05672 32.5794L4.848 31.968ZM26.1397 32.5737C28.7539 29.1393 30.04 24.6838 30.04 19.2H28.04C28.04 24.3722 26.8301 28.3647 24.5483 31.3623L26.1397 32.5737ZM30.04 19.2C30.04 13.7183 28.7548 9.25854 26.1353 5.86855L24.5527 7.09145C26.8292 10.0375 28.04 14.0257 28.04 19.2H30.04ZM26.1397 5.87431C23.4831 2.38426 19.7666 0.679998 15.12 0.679998V2.68C19.2094 2.68 22.3089 4.14373 24.5483 7.08568L26.1397 5.87431ZM15.12 0.679998C10.4776 0.679998 6.71121 2.38123 4.0523 5.87431L5.6437 7.08568C7.88079 4.14677 11.0264 2.68 15.12 2.68V0.679998ZM4.05672 5.86855C1.43331 9.26355 0.2 13.7267 0.2 19.2H2.2C2.2 14.0173 3.36669 10.0324 5.63929 7.09145L4.05672 5.86855ZM0.2 19.2C0.2 24.6755 1.43423 29.1343 4.0523 32.5737L5.6437 31.3623C3.36577 28.3697 2.2 24.3805 2.2 19.2H0.2ZM4.05672 32.5794C6.71538 36.0201 10.4789 37.72 15.12 37.72V35.72C11.0251 35.72 7.87662 34.2519 5.63929 31.3566L4.05672 32.5794ZM15.12 37.72C19.7653 37.72 23.4789 36.0171 26.1353 32.5794L24.5527 31.3566C22.3131 34.2549 19.2107 35.72 15.12 35.72V37.72ZM10.792 19.2C10.792 16.2166 11.2323 14.1355 11.9889 12.832C12.6977 11.6106 13.7 11.032 15.12 11.032V9.032C12.988 9.032 11.3263 9.98936 10.2591 11.828C9.23969 13.5845 8.792 16.0874 8.792 19.2H10.792ZM15.12 11.032C16.54 11.032 17.5423 11.6106 18.2511 12.832C19.0077 14.1355 19.448 16.2166 19.448 19.2H21.448C21.448 16.0874 21.0003 13.5845 19.9809 11.828C18.9137 9.98936 17.252 9.032 15.12 9.032V11.032ZM19.448 19.2C19.448 22.1834 19.0077 24.2645 18.2511 25.568C17.5423 26.7894 16.54 27.368 15.12 27.368V29.368C17.252 29.368 18.9137 28.4106 19.9809 26.572C21.0003 24.8155 21.448 22.3126 21.448 19.2H19.448ZM15.12 27.368C13.7 27.368 12.6977 26.7894 11.9889 25.568C11.2323 24.2645 10.792 22.1834 10.792 19.2H8.792C8.792 22.3126 9.23969 24.8155 10.2591 26.572C11.3263 28.4106 12.988 29.368 15.12 29.368V27.368ZM58.8593 36V37H59.8593V36H58.8593ZM58.8593 27.696H59.8593V26.696H58.8593V27.696ZM48.3473 27.696L47.6257 27.0036L46.0017 28.696H48.3473V27.696ZM52.9072 22.944L52.1861 22.2513L52.1857 22.2516L52.9072 22.944ZM54.8273 4.56L54.1791 5.32154L54.1878 5.32893L54.1967 5.33611L54.8273 4.56ZM34.8112 9.408L33.8921 9.01408L33.5373 9.84194L34.3237 10.2811L34.8112 9.408ZM42.2033 13.536L41.7157 14.4091L42.685 14.9504L43.1224 13.9299L42.2033 13.536ZM46.4753 18L47.2014 18.6876L47.2106 18.6777L46.4753 18ZM35.3392 29.76L34.6131 29.0724L34.3392 29.3617V29.76H35.3392ZM35.3392 36H34.3392V37H35.3392V36ZM59.8593 36V27.696H57.8593V36H59.8593ZM58.8593 26.696H48.3473V28.696H58.8593V26.696ZM49.0688 28.3884L53.6288 23.6364L52.1857 22.2516L47.6257 27.0036L49.0688 28.3884ZM53.6284 23.6367C57.1939 19.9248 59.2832 16.6128 59.2832 12.336H57.2832C57.2832 15.8352 55.6286 18.6672 52.1861 22.2513L53.6284 23.6367ZM59.2832 12.336C59.2832 8.76233 58.0246 5.86933 55.4578 3.78388L54.1967 5.33611C56.2379 6.99466 57.2832 9.28567 57.2832 12.336H59.2832ZM55.4754 3.79846C53.0225 1.71091 50.0509 0.679998 46.6193 0.679998V2.68C49.6196 2.68 52.12 3.56908 54.1791 5.32154L55.4754 3.79846ZM46.6193 0.679998C41.1073 0.679998 36.2189 3.58478 33.8921 9.01408L35.7304 9.80192C37.7236 5.15121 41.8592 2.68 46.6193 2.68V0.679998ZM34.3237 10.2811L41.7157 14.4091L42.6908 12.6629L35.2988 8.53491L34.3237 10.2811ZM43.1224 13.9299C43.5793 12.8638 44.1242 12.1448 44.7093 11.6944C45.2818 11.2537 45.9408 11.032 46.7152 11.032V9.032C45.5217 9.032 44.4287 9.38634 43.4892 10.1096C42.5623 10.8232 41.8352 11.8561 41.2841 13.1421L43.1224 13.9299ZM46.7152 11.032C47.4556 11.032 47.9314 11.2473 48.2154 11.5179C48.4947 11.7841 48.6912 12.201 48.6912 12.816H50.6912C50.6912 11.751 50.3358 10.7759 49.5951 10.0701C48.8591 9.36867 47.8469 9.032 46.7152 9.032V11.032ZM48.6912 12.816C48.6912 13.3112 48.5422 13.8077 48.0905 14.5035C47.6209 15.2267 46.8729 16.0928 45.7399 17.3223L47.2106 18.6777C48.3336 17.4592 49.1936 16.4773 49.768 15.5925C50.3603 14.6803 50.6912 13.8088 50.6912 12.816H48.6912ZM45.7491 17.3124L34.6131 29.0724L36.0654 30.4476L47.2014 18.6876L45.7491 17.3124ZM34.3392 29.76V36H36.3392V29.76H34.3392ZM35.3392 37H58.8593V35H35.3392V37Z"
      fill="#827F98"
    />
  </svg>
);

export const Three = () => (
  <svg
    width="60"
    height="38"
    viewBox="0 0 60 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M25.344 31.968L26.1353 32.5795L26.1397 32.5737L25.344 31.968ZM25.344 6.48L24.5483 7.0857L24.5527 7.09145L25.344 6.48ZM4.848 6.48L5.63931 7.09146L5.6437 7.08568L4.848 6.48ZM4.848 31.968L4.05227 32.5737L4.05672 32.5794L4.848 31.968ZM26.1397 32.5737C28.7539 29.1393 30.04 24.6838 30.04 19.2H28.04C28.04 24.3722 26.8301 28.3647 24.5483 31.3623L26.1397 32.5737ZM30.04 19.2C30.04 13.7183 28.7548 9.25854 26.1353 5.86855L24.5527 7.09145C26.8292 10.0375 28.04 14.0257 28.04 19.2H30.04ZM26.1397 5.87431C23.4831 2.38426 19.7666 0.679998 15.12 0.679998V2.68C19.2094 2.68 22.3089 4.14373 24.5483 7.08568L26.1397 5.87431ZM15.12 0.679998C10.4776 0.679998 6.71121 2.38123 4.0523 5.87431L5.6437 7.08568C7.88079 4.14677 11.0264 2.68 15.12 2.68V0.679998ZM4.05672 5.86855C1.43331 9.26355 0.2 13.7267 0.2 19.2H2.2C2.2 14.0173 3.36669 10.0324 5.63929 7.09145L4.05672 5.86855ZM0.2 19.2C0.2 24.6755 1.43423 29.1343 4.0523 32.5737L5.6437 31.3623C3.36577 28.3697 2.2 24.3805 2.2 19.2H0.2ZM4.05672 32.5794C6.71538 36.0201 10.4789 37.72 15.12 37.72V35.72C11.0251 35.72 7.87662 34.2519 5.63929 31.3566L4.05672 32.5794ZM15.12 37.72C19.7653 37.72 23.4789 36.0171 26.1353 32.5794L24.5527 31.3566C22.3131 34.2549 19.2107 35.72 15.12 35.72V37.72ZM10.792 19.2C10.792 16.2166 11.2323 14.1355 11.9889 12.832C12.6977 11.6106 13.7 11.032 15.12 11.032V9.032C12.988 9.032 11.3263 9.98936 10.2591 11.828C9.23969 13.5845 8.792 16.0874 8.792 19.2H10.792ZM15.12 11.032C16.54 11.032 17.5423 11.6106 18.2511 12.832C19.0077 14.1355 19.448 16.2166 19.448 19.2H21.448C21.448 16.0874 21.0003 13.5845 19.9809 11.828C18.9137 9.98936 17.252 9.032 15.12 9.032V11.032ZM19.448 19.2C19.448 22.1834 19.0077 24.2645 18.2511 25.568C17.5423 26.7894 16.54 27.368 15.12 27.368V29.368C17.252 29.368 18.9137 28.4106 19.9809 26.572C21.0003 24.8155 21.448 22.3126 21.448 19.2H19.448ZM15.12 27.368C13.7 27.368 12.6977 26.7894 11.9889 25.568C11.2323 24.2645 10.792 22.1834 10.792 19.2H8.792C8.792 22.3126 9.23969 24.8155 10.2591 26.572C11.3263 28.4106 12.988 29.368 15.12 29.368V27.368ZM57.3356 9.168L58.1117 9.79859L58.3356 9.52304V9.168H57.3356ZM57.3356 2.4H58.3356V1.4H57.3356V2.4ZM35.4956 2.4V1.4H34.4956V2.4H35.4956ZM35.4956 10.608H34.4956V11.608H35.4956V10.608ZM46.7756 10.608L47.5498 11.2409L48.8848 9.608H46.7756V10.608ZM41.3996 17.184L40.6254 16.5511L40.1541 17.1276L40.5713 17.7443L41.3996 17.184ZM44.7116 22.08L43.8833 22.6403L44.1808 23.08H44.7116V22.08ZM41.9276 24.864L42.8838 24.5713L42.5179 23.3759L41.4321 23.9954L41.9276 24.864ZM34.4396 29.136L33.9441 28.2674L33.1979 28.6931L33.5063 29.495L34.4396 29.136ZM55.3196 33.792L54.6779 33.0251L55.3196 33.792ZM51.7196 16.08L50.9435 15.4494L50.0151 16.5921L51.4195 17.0339L51.7196 16.08ZM58.3356 9.168V2.4H56.3356V9.168H58.3356ZM57.3356 1.4H35.4956V3.4H57.3356V1.4ZM34.4956 2.4V10.608H36.4956V2.4H34.4956ZM35.4956 11.608H46.7756V9.608H35.4956V11.608ZM46.0014 9.97507L40.6254 16.5511L42.1738 17.8169L47.5498 11.2409L46.0014 9.97507ZM40.5713 17.7443L43.8833 22.6403L45.5399 21.5197L42.2279 16.6237L40.5713 17.7443ZM44.7116 23.08H46.5356V21.08H44.7116V23.08ZM46.5356 23.08C47.6087 23.08 48.2998 23.3436 48.7059 23.6853C49.0892 24.0077 49.3276 24.4894 49.3276 25.2H51.3276C51.3276 23.9906 50.894 22.9123 49.9933 22.1547C49.1155 21.4164 47.9105 21.08 46.5356 21.08V23.08ZM49.3276 25.2C49.3276 25.9124 49.0875 26.4105 48.6977 26.7457C48.2893 27.0969 47.5997 27.368 46.5356 27.368V29.368C47.9196 29.368 49.126 29.0151 50.0016 28.2623C50.8957 27.4935 51.3276 26.4076 51.3276 25.2H49.3276ZM46.5356 27.368C45.5263 27.368 44.7808 27.1233 44.2236 26.701C43.6634 26.2765 43.199 25.6009 42.8838 24.5713L40.9714 25.1567C41.3762 26.4791 42.0398 27.5555 43.0156 28.295C43.9944 29.0367 45.193 29.368 46.5356 29.368V27.368ZM41.4321 23.9954L33.9441 28.2674L34.9352 30.0046L42.4232 25.7326L41.4321 23.9954ZM33.5063 29.495C35.6053 34.9524 40.6457 37.72 46.5356 37.72V35.72C41.2895 35.72 37.114 33.3036 35.373 28.777L33.5063 29.495ZM46.5356 37.72C50.2332 37.72 53.4003 36.7019 55.9613 34.5589L54.6779 33.0251C52.535 34.8181 49.846 35.72 46.5356 35.72V37.72ZM55.9613 34.5589C58.5771 32.3703 59.8716 29.2847 59.8716 25.44H57.8716C57.8716 28.7953 56.7662 31.2777 54.6779 33.0251L55.9613 34.5589ZM59.8716 25.44C59.8716 20.342 56.6551 16.5844 52.0197 15.1261L51.4195 17.0339C55.3281 18.2636 57.8716 21.322 57.8716 25.44H59.8716ZM52.4957 16.7106L58.1117 9.79859L56.5595 8.53741L50.9435 15.4494L52.4957 16.7106Z"
      fill="#827F98"
    />
  </svg>
);

export const SearchIcon = ({ color = "#2C2C2C" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2049 12.952L18 16.7462L16.7462 18L12.952 14.2049C11.5402 15.3366 9.78419 15.9522 7.9748 15.9496C3.57271 15.9496 0 12.3769 0 7.9748C0 3.57271 3.57271 0 7.9748 0C12.3769 0 15.9496 3.57271 15.9496 7.9748C15.9522 9.78419 15.3366 11.5402 14.2049 12.952ZM12.4274 12.2945C13.5519 11.138 14.18 9.58786 14.1774 7.9748C14.1774 4.54741 11.4013 1.77218 7.9748 1.77218C4.54741 1.77218 1.77218 4.54741 1.77218 7.9748C1.77218 11.4013 4.54741 14.1774 7.9748 14.1774C9.58786 14.18 11.138 13.5519 12.2945 12.4274L12.4274 12.2945Z"
      fill={color}
    />
  </svg>
);

export const DiscoverIcon = () => (
  <svg
    width="43"
    height="26"
    viewBox="0 0 43 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2028 11.842L24.5693 11.8413V13.6145L19.2028 13.6139C19.0048 15.4124 18.1984 17.0893 16.9171 18.367C13.8044 21.4797 8.75178 21.4797 5.63903 18.367C2.52629 15.2542 2.52629 10.2016 5.63903 7.08889C8.75178 3.97614 13.8044 3.97614 16.9171 7.08889C18.1984 8.3665 19.0048 10.0434 19.2028 11.842ZM17.481 12.6339C17.4584 11.021 16.8064 9.48082 15.664 8.34201C13.2404 5.91848 9.31505 5.9191 6.89215 8.34201C4.46862 10.7655 4.46862 14.6903 6.89215 17.1138C9.31505 19.5367 13.2404 19.5374 15.664 17.1138C16.8064 15.975 17.4584 14.4348 17.481 12.8219V12.6339Z"
      fill="#2C2C2C"
    />
    <path
      d="M22.9808 11.842L17.6143 11.8413V13.6145L22.9808 13.6139C23.1788 15.4124 23.9852 17.0893 25.2665 18.367C28.3792 21.4797 33.4318 21.4797 36.5446 18.367C39.6573 15.2542 39.6573 10.2016 36.5446 7.08889C33.4318 3.97614 28.3792 3.97614 25.2665 7.08889C23.9852 8.3665 23.1788 10.0434 22.9808 11.842ZM24.7026 12.6339C24.7252 11.021 25.3772 9.48082 26.5196 8.34201C28.9431 5.91848 32.8685 5.9191 35.2914 8.34201C37.715 10.7655 37.715 14.6903 35.2914 17.1138C32.8685 19.5367 28.9431 19.5374 26.5196 17.1138C25.3772 15.975 24.7252 14.4348 24.7026 12.8219V12.6339Z"
      fill="#2C2C2C"
    />
  </svg>
);

export const CompareIcon = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.172 10.7779L13.5 10.778L15 10.7778L17 10.7779L8.222 19.5559L6.808 18.1419L12.172 12.7779H0V10.7779H12.172Z"
      fill="#2C2C2C"
    />
    <path
      d="M4.828 8.778L3.5 8.77783L2 8.77806L0 8.778L8.778 -1.90735e-06L10.192 1.414L4.828 6.778H17V8.778H4.828Z"
      fill="#2C2C2C"
    />
  </svg>
);

export const PlusIcon = ({ customClass }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={customClass}
  >
    <path
      d="M9.99985 8.00021L17.0002 8.00021L17.0002 9.9999L9.99985 9.9999V17.0003H8.00015V9.9999L0.999794 9.9999L0.999793 8.00021L8.00015 8.00021L8.00015 0.999849H9.99985L9.99985 8.00021Z"
      fill="#565656"
    />
  </svg>
);

export const MinusIcon = ({ customClass }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={customClass}
  >
    <path
      d="M9.99985 8.00021L17.0002 8.00021L17.0002 9.9999L9.99985 9.9999L8.00015 10.0003L0.999794 9.9999L0.999793 8.00021L8.00015 8.00021H9.99985Z"
      fill="#565656"
    />
  </svg>
);

export const TimesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 7.77813L17.7781 0L20 2.22187L12.2219 10L20 17.7781L17.7781 20L10 12.2219L2.22187 20L0 17.7781L7.77813 10L0 2.22187L2.22187 0L10 7.77813Z"
      // fill="black"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9992 1.54431C15.4 1.80938 14.7645 1.98346 14.1138 2.06079C14.7996 1.65061 15.313 1.00507 15.5581 0.244466C14.9144 0.627512 14.2088 0.895957 13.4733 1.04117C12.9793 0.512582 12.3245 0.16202 11.6106 0.0439833C10.8968 -0.0740531 10.164 0.0470495 9.52611 0.388464C8.88822 0.729878 8.38099 1.27248 8.08329 1.9319C7.78559 2.59133 7.71409 3.33064 7.87991 4.03489C6.57465 3.96947 5.29775 3.63028 4.13209 3.03934C2.96644 2.44839 1.93809 1.61892 1.11381 0.604749C0.822049 1.10589 0.668725 1.67557 0.669545 2.25546C0.669545 3.3936 1.24882 4.3991 2.12951 4.98779C1.60833 4.97139 1.09861 4.83064 0.642857 4.57728V4.61809C0.643014 5.3761 0.905313 6.11073 1.38528 6.69742C1.86525 7.28411 2.53335 7.68675 3.27629 7.83709C2.79248 7.9682 2.28517 7.98753 1.79278 7.8936C2.00225 8.54606 2.41052 9.11668 2.96043 9.52556C3.51034 9.93444 4.17436 10.1611 4.8595 10.1738C4.17856 10.7086 3.39888 11.1039 2.56506 11.3372C1.73123 11.5705 0.859598 11.6371 0 11.5333C1.50055 12.4983 3.24733 13.0107 5.0314 13.009C11.0699 13.009 14.3721 8.00663 14.3721 3.66833C14.3721 3.52704 14.3681 3.38418 14.3619 3.24447C15.0046 2.77992 15.5593 2.20445 16 1.54509L15.9992 1.54431Z"
      fill="#161616"
    />
  </svg>
);

export const WhatsAppIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.223914 16.3115L1.30551 12.3371C0.592824 11.1154 0.218391 9.72591 0.220714 8.31152C0.220714 3.89312 3.80231 0.311523 8.22071 0.311523C12.6391 0.311523 16.2207 3.89312 16.2207 8.31152C16.2207 12.7299 12.6391 16.3115 8.22071 16.3115C6.80693 16.3138 5.41804 15.9396 4.19671 15.2275L0.223914 16.3115ZM5.33351 4.55792C5.2302 4.56434 5.12925 4.59155 5.03671 4.63792C4.94993 4.68706 4.87071 4.7485 4.80151 4.82032C4.70551 4.91072 4.65111 4.98912 4.59271 5.06512C4.29704 5.44992 4.138 5.92225 4.14071 6.40752C4.14231 6.79952 4.24471 7.18112 4.40471 7.53792C4.73191 8.25952 5.27031 9.02352 5.98151 9.73152C6.15271 9.90192 6.31991 10.0731 6.49991 10.2323C7.38262 11.0095 8.43451 11.5699 9.57191 11.8691L10.0271 11.9387C10.1751 11.9467 10.3231 11.9355 10.4719 11.9283C10.7049 11.9163 10.9324 11.8532 11.1383 11.7435C11.2711 11.6731 11.3335 11.6379 11.4447 11.5675C11.4447 11.5675 11.4791 11.5451 11.5447 11.4955C11.6527 11.4155 11.7191 11.3587 11.8087 11.2651C11.8751 11.1963 11.9327 11.1155 11.9767 11.0235C12.0391 10.8931 12.1015 10.6443 12.1271 10.4371C12.1463 10.2787 12.1407 10.1923 12.1383 10.1387C12.1351 10.0531 12.0639 9.96432 11.9863 9.92672L11.5207 9.71792C11.5207 9.71792 10.8247 9.41472 10.3999 9.22112C10.3551 9.20159 10.3071 9.19048 10.2583 9.18832C10.2036 9.1827 10.1483 9.18886 10.0961 9.20638C10.0439 9.2239 9.99615 9.25239 9.95591 9.28992V9.28832C9.95191 9.28832 9.89831 9.33392 9.31991 10.0347C9.28671 10.0793 9.24098 10.113 9.18855 10.1316C9.13612 10.1501 9.07936 10.1526 9.02551 10.1387C8.97338 10.1248 8.92232 10.1071 8.87271 10.0859C8.77351 10.0443 8.73911 10.0283 8.67111 9.99872L8.66711 9.99712C8.20944 9.7973 7.78569 9.52739 7.41111 9.19712C7.31031 9.10912 7.21671 9.01312 7.12071 8.92032C6.80597 8.61891 6.53168 8.27793 6.30471 7.90592L6.25751 7.82992C6.22361 7.77885 6.1962 7.72376 6.17591 7.66592C6.14551 7.54832 6.22471 7.45392 6.22471 7.45392C6.22471 7.45392 6.41911 7.24112 6.50951 7.12592C6.58478 7.03018 6.65501 6.93057 6.71991 6.82752C6.81431 6.67552 6.84391 6.51952 6.79431 6.39872C6.57031 5.85152 6.33831 5.30672 6.09991 4.76592C6.05271 4.65872 5.91271 4.58192 5.78551 4.56672C5.74231 4.56192 5.69911 4.55712 5.65591 4.55392C5.54848 4.54858 5.44082 4.54965 5.33351 4.55712V4.55792Z"
      fill="#161616"
    />
  </svg>
);

export const MailIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.8 0H15.2C15.4122 0 15.6157 0.0842854 15.7657 0.234315C15.9157 0.384344 16 0.587827 16 0.8V13.6C16 13.8122 15.9157 14.0157 15.7657 14.1657C15.6157 14.3157 15.4122 14.4 15.2 14.4H0.8C0.587827 14.4 0.384344 14.3157 0.234315 14.1657C0.0842854 14.0157 0 13.8122 0 13.6V0.8C0 0.587827 0.0842854 0.384344 0.234315 0.234315C0.384344 0.0842854 0.587827 0 0.8 0ZM8.048 6.9464L2.9184 2.5904L1.8824 3.8096L8.0584 9.0536L14.1232 3.8056L13.0768 2.5952L8.0488 6.9464H8.048Z"
      fill="#161616"
    />
  </svg>
);

export const MenuCloseIcon = ({ clickAction, customClass }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={clickAction}
    className={customClass}
  >
    <path
      d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 8.586L7.172 5.757L5.757 7.172L8.586 10L5.757 12.828L7.172 14.243L10 11.414L12.828 14.243L14.243 12.828L11.414 10L14.243 7.172L12.828 5.757L10 8.586Z"
      fill="#D33715"
    />
  </svg>
);

export const LinkIcon = () => (
  <svg
    width="7"
    height="7"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83537 1.98802L0.823392 7L-4.76837e-07 6.17661L5.01198 1.16463H0.594543V-4.76837e-07H7V6.40546H5.83537V1.9886V1.98802Z"
      fill="#004AD9"
    />
  </svg>
);

export const CircleArrow = ({ color = "white" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM10 8V5L15 10H6V8H10Z"
      fill={color}
    />
    <path d="M10 15V12H6V10H15L10 15Z" fill={color} />
  </svg>
);

export const TradeValueIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.51761 12.688L4.64561 9.56L6.90881 11.8224L10.5656 8.1664L12 9.6V5.6H8.00001L9.43441 7.0344L6.90881 9.56L4.64641 7.2968L0.689606 11.2536C0.233549 10.2296 -0.00143016 9.12095 6.54861e-06 8C6.54861e-06 3.5816 3.58161 0 8.00001 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8.00001 16C6.73441 16.0008 5.48671 15.701 4.35969 15.1252C3.23267 14.5493 2.25857 13.714 1.51761 12.688Z"
      fill="#00FDC0"
    />
  </svg>
);

export const FilterIcon = ({ color = "black" }) => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z" fill={color} />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.61073 2.55667L9.44333 5.38994L2.8326 12H0V9.16673L6.61073 2.55601V2.55667ZM7.55493 1.61247L8.97123 0.195508C9.09645 0.0703245 9.26626 0 9.44333 0C9.62039 0 9.7902 0.0703245 9.91543 0.195508L11.8045 2.08457C11.9297 2.2098 12 2.37961 12 2.55667C12 2.73374 11.9297 2.90355 11.8045 3.02877L10.3875 4.44507L7.55493 1.61247Z"
      fill="#004AD9"
    />
  </svg>
);

export const BackArrow = ({ color = "#2A2A2A" }) => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.82832 6.88893L7.77832 11.8389L6.36432 13.2529L0.000320991 6.88893L6.36432 0.524929L7.77832 1.93893L2.82832 6.88893Z"
      fill={color}
    />
  </svg>
);

export const InterconnectedEmpty = () => (
  <svg
    width="184"
    height="184"
    viewBox="0 0 184 184"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="92"
      cy="92"
      r="91"
      fill="#EFF0F5"
      stroke="#E0E0E0"
      strokeWidth="2"
    />
    <path
      d="M36.922 120.857C32.4929 113.185 35.1213 103.376 42.7927 98.9468L51.4742 93.9345L70.3204 126.577L61.6389 131.589C53.9674 136.018 44.158 133.39 39.7288 125.718L36.922 120.857Z"
      fill="white"
    />
    <path
      d="M49.4688 90.4619L53.9831 87.8556L76.6386 127.096L72.1242 129.702L49.4688 90.4619Z"
      fill="white"
    />
    <path
      d="M30.2695 123.771L44.1599 115.752L47.7688 122.002L33.8784 130.022L30.2695 123.771Z"
      fill="white"
    />
    <path
      d="M144.92 58.5041C140.491 50.8326 130.681 48.2042 123.01 52.6333L114.328 57.6456L133.175 90.288L141.856 85.2757C149.528 80.8466 152.156 71.0372 147.727 63.3657L144.92 58.5041Z"
      fill="white"
    />
    <path
      d="M112.324 54.173L107.81 56.7793L130.465 96.0197L134.98 93.4133L112.324 54.173Z"
      fill="white"
    />
    <path
      d="M150.77 54.2007L136.879 62.2203L140.488 68.471L154.378 60.4514L150.77 54.2007Z"
      fill="white"
    />
    <path
      d="M85.7274 116.48C72.3756 112.902 64.4526 99.1793 68.0302 85.8276C71.6078 72.4758 85.3309 64.5528 98.6827 68.1304C112.034 71.708 119.957 85.4311 116.38 98.7828C112.802 112.135 99.0792 120.058 85.7274 116.48ZM90.4353 89.24L80.7654 86.6489L79.4698 91.4839L89.1398 94.0749L86.5487 103.745L91.3837 105.04L93.9748 95.3705L103.645 97.9615L104.94 93.1265L95.2703 90.5355L97.8613 80.8655L93.0264 79.57L90.4353 89.24Z"
      fill="#D3D9DD"
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.66667H11.3333C11.5101 4.66667 11.6797 4.7369 11.8047 4.86193C11.9298 4.98695 12 5.15652 12 5.33333V13.3333C12 13.5101 11.9298 13.6797 11.8047 13.8047C11.6797 13.9298 11.5101 14 11.3333 14H0.666667C0.489856 14 0.320286 13.9298 0.195262 13.8047C0.0702379 13.6797 0 13.5101 0 13.3333V5.33333C0 5.15652 0.0702379 4.98695 0.195262 4.86193C0.320286 4.7369 0.489856 4.66667 0.666667 4.66667H2V4C2 2.93913 2.42143 1.92172 3.17157 1.17157C3.92172 0.421427 4.93913 0 6 0C7.06087 0 8.07828 0.421427 8.82843 1.17157C9.57857 1.92172 10 2.93913 10 4V4.66667ZM5.33333 9.82133V11.3333H6.66667V9.82133C6.92086 9.67458 7.11952 9.44805 7.23184 9.17688C7.34416 8.90571 7.36387 8.60505 7.2879 8.32154C7.21193 8.03803 7.04454 7.78751 6.81168 7.60883C6.57882 7.43015 6.29351 7.3333 6 7.3333C5.70649 7.3333 5.42118 7.43015 5.18832 7.60883C4.95546 7.78751 4.78807 8.03803 4.7121 8.32154C4.63613 8.60505 4.65584 8.90571 4.76816 9.17688C4.88048 9.44805 5.07914 9.67458 5.33333 9.82133ZM8.66667 4.66667V4C8.66667 3.29276 8.38572 2.61448 7.88562 2.11438C7.38552 1.61428 6.70724 1.33333 6 1.33333C5.29276 1.33333 4.61448 1.61428 4.11438 2.11438C3.61428 2.61448 3.33333 3.29276 3.33333 4V4.66667H8.66667Z"
      fill="#A6A8AE"
    />
  </svg>
);

export const CommodityLinkIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 0.25V1.75H1.75V12.25H12.25V8.5H13.75V13C13.75 13.1989 13.671 13.3897 13.5303 13.5303C13.3897 13.671 13.1989 13.75 13 13.75H1C0.801088 13.75 0.610322 13.671 0.46967 13.5303C0.329018 13.3897 0.25 13.1989 0.25 13V1C0.25 0.801088 0.329018 0.610322 0.46967 0.46967C0.610322 0.329018 0.801088 0.25 1 0.25H5.5ZM11.2803 3.78025L7 8.0605L5.9395 7L10.2197 2.71975L7.75 0.25H13.75V6.25L11.2803 3.78025Z"
      fill="#161616"
    />
  </svg>
);

export const TwitterCircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19.5" stroke="white" />
    <path
      d="M29.4776 14.8045C28.799 15.1047 28.0793 15.3018 27.3425 15.3894C28.1192 14.9249 28.7004 14.1939 28.978 13.3325C28.2492 13.7663 27.45 14.0703 26.6172 14.2347C26.0577 13.6361 25.3161 13.2391 24.5078 13.1055C23.6994 12.9718 22.8695 13.1089 22.1472 13.4956C21.4248 13.8822 20.8504 14.4967 20.5133 15.2434C20.1761 15.9902 20.0952 16.8274 20.2829 17.625C18.8048 17.5509 17.3588 17.1668 16.0387 16.4975C14.7187 15.8283 13.5542 14.889 12.6207 13.7405C12.2903 14.308 12.1167 14.9532 12.1176 15.6098C12.1176 16.8987 12.7736 18.0374 13.7709 18.7041C13.1807 18.6855 12.6035 18.5261 12.0874 18.2392V18.2854C12.0876 19.1438 12.3846 19.9757 12.9281 20.6401C13.4717 21.3045 14.2282 21.7605 15.0696 21.9307C14.5217 22.0792 13.9472 22.1011 13.3896 21.9947C13.6268 22.7336 14.0892 23.3798 14.7119 23.8428C15.3346 24.3059 16.0866 24.5625 16.8625 24.577C16.0914 25.1826 15.2084 25.6303 14.2642 25.8944C13.3199 26.1586 12.3328 26.2341 11.3594 26.1165C13.0587 27.2093 15.0368 27.7895 17.0572 27.7876C23.8954 27.7876 27.6349 22.1227 27.6349 17.2098C27.6349 17.0498 27.6305 16.8881 27.6234 16.7298C28.3513 16.2038 28.9795 15.5521 29.4785 14.8054L29.4776 14.8045Z"
      fill="white"
    />
  </svg>
);

export const FacebookCircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19.5" stroke="white" />
    <path
      d="M22.2222 21.7769H24.4444L25.3333 18.2214H22.2222V16.4436C22.2222 15.528 22.2222 14.6658 24 14.6658H25.3333V11.6791C25.0436 11.6409 23.9493 11.5547 22.7938 11.5547C20.3804 11.5547 18.6667 13.0276 18.6667 15.7325V18.2214H16V21.7769H18.6667V29.3325H22.2222V21.7769Z"
      fill="white"
    />
  </svg>
);

export const LinkedInCircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19.5" stroke="white" />
    <path
      d="M26.0745 26.079H23.7056V22.3661C23.7056 21.4808 23.6878 20.3412 22.47 20.3412C21.2354 20.3412 21.0469 21.3048 21.0469 22.3012V26.079H18.6771V18.4443H20.9527V19.4843H20.9838C21.302 18.8852 22.0754 18.2514 23.2309 18.2514C25.6309 18.2514 26.0754 19.8319 26.0754 21.8879V26.079H26.0745ZM16.0016 17.3999C15.8207 17.4001 15.6416 17.3647 15.4745 17.2955C15.3074 17.2264 15.1556 17.125 15.0278 16.9971C14.8999 16.8692 14.7986 16.7173 14.7296 16.5501C14.6606 16.383 14.6252 16.2038 14.6256 16.023C14.6258 15.7509 14.7066 15.4849 14.858 15.2587C15.0093 15.0325 15.2243 14.8563 15.4758 14.7523C15.7273 14.6483 16.004 14.6212 16.2709 14.6745C16.5378 14.7278 16.7829 14.859 16.9752 15.0515C17.1675 15.2441 17.2984 15.4894 17.3513 15.7563C17.4042 16.0233 17.3768 16.2999 17.2725 16.5513C17.1682 16.8026 16.9917 17.0174 16.7653 17.1685C16.5389 17.3195 16.2728 17.4001 16.0007 17.3999H16.0016ZM17.1891 26.079H14.8131V18.4443H17.19V26.079H17.1891ZM27.2611 12.4443H13.6247C12.9705 12.4443 12.4434 12.9599 12.4434 13.5972V27.2914C12.4434 27.9288 12.9714 28.4443 13.6238 28.4443H27.2576C27.91 28.4443 28.4434 27.9288 28.4434 27.2914V13.5972C28.4434 12.9599 27.91 12.4443 27.2576 12.4443H27.2602H27.2611Z"
      fill="white"
    />
  </svg>
);

export const LinkCircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19.5" stroke="white" />
    <path
      d="M26.1011 23.5874L24.8442 22.3288L26.1011 21.0719C26.5168 20.6598 26.847 20.1697 27.0727 19.6297C27.2985 19.0897 27.4154 18.5105 27.4167 17.9252C27.4179 17.3399 27.3036 16.7601 27.0802 16.2191C26.8568 15.6781 26.5288 15.1866 26.1149 14.7728C25.7011 14.3589 25.2095 14.0308 24.6685 13.8075C24.1276 13.5841 23.5478 13.4697 22.9625 13.471C22.3772 13.4723 21.7979 13.5892 21.2579 13.8149C20.7179 14.0407 20.2278 14.3709 19.8158 14.7865L18.5589 16.0443L17.3011 14.7874L18.5598 13.5305C19.7267 12.3636 21.3095 11.708 22.9598 11.708C24.6101 11.708 26.1928 12.3636 27.3598 13.5305C28.5267 14.6975 29.1823 16.2802 29.1823 17.9305C29.1823 19.5809 28.5267 21.1636 27.3598 22.3305L26.102 23.5874H26.1011ZM23.5874 26.1012L22.3296 27.3581C21.1626 28.5251 19.5799 29.1806 17.9296 29.1806C16.2793 29.1806 14.6965 28.5251 13.5296 27.3581C12.3626 26.1912 11.707 24.6084 11.707 22.9581C11.707 21.3078 12.3626 19.7251 13.5296 18.5581L14.7873 17.3012L16.0442 18.5599L14.7873 19.8168C14.3717 20.2288 14.0415 20.7189 13.8157 21.2589C13.59 21.7989 13.4731 22.3782 13.4718 22.9635C13.4705 23.5488 13.5849 24.1285 13.8083 24.6695C14.0317 25.2105 14.3597 25.702 14.7736 26.1159C15.1874 26.5298 15.679 26.8578 16.2199 27.0812C16.7609 27.3046 17.3407 27.4189 17.926 27.4176C18.5113 27.4164 19.0905 27.2995 19.6305 27.0737C20.1705 26.848 20.6606 26.5178 21.0727 26.1021L22.3296 24.8452L23.5874 26.1021V26.1012ZM22.958 16.6728L24.2158 17.9305L17.9305 24.215L16.6727 22.9581L22.958 16.6737V16.6728Z"
      fill="white"
    />
  </svg>
);
